import { SubscriptionAggregateOutput } from '@allocab/allocab-driver-service-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { QueryOptions } from '../services/datastore/types';
import { driverApi } from '../services/network/Api';

const fetchUserSubscription = () => driverApi.get<void, SubscriptionAggregateOutput>('/v1/subscription/user/me');

export const useFetchUserSubscription = (
  options: QueryOptions<typeof queryKeys.user.fetchUserSubscription, SubscriptionAggregateOutput> = {},
) => useQuery(queryKeys.user.fetchUserSubscription(), fetchUserSubscription, options);
